import { helper } from '@ember/component/helper';

// Hash.step is optional.
// Hash.func can be ceil, floor, round, or left blank.
// round(2.74, 0.1) = 2.7
// round(2.74, 0.25) = 2.75
// round(2.74, 0.5) = 2.5
// round(2.74, 1.0) = 3.0
export function mathRound(params, hash) {
    let step = hash.step;
    let value = params[0];
    let func = hash.func || 'round';

    step || (step = 1.0);
    let inv = 1.0 / step;

    if (hash.adjustedStep) {
        // Round to the nearest step UNLESS
        // 1 or less. Then, round up to the nearest 1/10th.
        // Unless the answer is .1 or less. Then round up to the nearest 1/100th.
        if (value <= 0.1) inv = 1.0 / 0.01;
        else if (value <= 1) inv = 1.0 / 0.1;
    }

    return Math[func](value * inv) / inv;
}

export default helper(mathRound);
